import { useEffect, useState, memo, useContext } from "react";
import Render from "../pages/canvas/paper/render";
import { functions } from "../firebase";
import { useParams } from "react-router-dom";
import styles from "./styles.module.css";
import useNoLoop from "../utils/usenoloop";
const loadPage = functions.httpsCallable("loadPageData");

function ComponentPreview({ block, editorRef, path }) {
  const [_block, setBlock] = useState(null);
  const [error, setError] = useState(false);
  const loop = useNoLoop(_block, path);
  const { appId } = useParams();

  useEffect(() => {
    if ((_block && _block.name !== block.component) || !_block) {
      loadPage({ appId, type: "components", pageId: block.component })
        .then(({ data }) => {
          // const loop = checkLoop(data, tree);

          setError(false);
          setBlock(data);
        })
        .catch(() => {
          setError(true);
        });
    }
  }, [block]);

  if (!_block) {
    return <div ref={editorRef}>loading...</div>;
  }

  if (loop) {
    return <div>Loop detected</div>;
  }

  if (error) {
    return <div ref={editorRef}>Error: Component not found</div>;
  }
  return (
    <div
      style={{
        left: 0,
        top: 0,
        right: 0,
        visibility: block.hidden ? "hidden" : "unset",
        display: "flex",
        backgroundColor: _block.props.backgroundColor,
        flexGrow: _block.props.flexGrow,
        position: _block.props.type,
        justifyContent: _block.props.justifyContent,
        ..._block.props.size,
      }}
      ref={editorRef}
    >
      {_block.children.map((block, index) => {
        const path = [];
        path.push(index);

        return (
          <Render
            key={block.id}
            block={block}
            disabled
            path={path}
            index={index}
          />
        );
      })}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 1,
        }}
        className={styles.cover}
      ></div>
    </div>
  );
}

export default memo(ComponentPreview);
